import React from 'react';
import { getIntl } from '../../../../utils/intl';
import GateButtons from './GateButtons';

const intl = getIntl('organization-client-invitation-step-complete-button', {
    next: 'Next',
    complete: 'Complete',
});

export type StepCompleteButtonOwnProps = {
    variant: 'next' | 'complete';
    onPress: () => void;
    isDisabled?: boolean;
    testID?: string;
};

export type StepCompleteButtonProps = StepCompleteButtonOwnProps;

const StepCompleteButton: React.FC<StepCompleteButtonProps> = ({ variant, onPress, isDisabled, testID }) => {
    return (
        <GateButtons
            primaryButtonProps={{
                variant: 'primary',
                title: variant === 'next' ? intl('next') : intl('complete'),
                onPress: onPress,
                icon: variant === 'next' ? 'ArrowRight' : 'CheckCircle',
                isDisabled: isDisabled,
                testID: testID,
            }}
        />
    );
};

export default React.memo(StepCompleteButton);
